import { createModel, RematchDispatch } from '@rematch/core';
import { storeName as layoutModelStore } from '../models/layout.model';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { getNewsByCode, getNewsByProjectCode } from '../../services/news.service';

export const storeName = 'newsEntity';

export const newsEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof newsEntity>) => ({
    async loadByKey(payload, state: RootModel) {
      const { locale } = state[layoutModelStore];
      const { newsKey } = payload;
      const dataResponse = await getNewsByCode(newsKey, locale.apiLanguage);
      this.saves([dataResponse]);
      return dataResponse;
    },

    async loadByProjectKey(payload, state: RootModel) {
      const { locale } = state[layoutModelStore];
      if (!payload) return;
      const { projectKey, page } = payload;
      const dataResponse = await getNewsByProjectCode(projectKey, locale.apiLanguage, page);
      const { content = [] } = dataResponse;
      const contentHaveTitle = (content || []).filter((item) => item.title);
      this.saves(contentHaveTitle);
      return dataResponse;
    },
  }),
});

export default newsEntity;
